// extracted by mini-css-extract-plugin
export default {"content":"Root_content__6WA6L"};